import { RouteProps } from '../../routes/AppRouter'
import { DownloadKits as Downloads } from '../../features/bedfilesKit'
import { Title } from '../../components/common/Title'

export const DownloadKits = (props: RouteProps) => {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <Downloads />
    </>
  )
}
